const PreloadBrands = ['hsbc'];
export default PreloadBrands;
